export const ReserveType = {
  Set: 'set',
  Group: 'group'
}
export type ReserveType = typeof ReserveType[keyof typeof ReserveType]

export const ReserveMethod = {
  AllBranch: '1',
  SpecifyBranch: '2'
}
export type ReserveMethod = typeof ReserveMethod[keyof typeof ReserveMethod]
